module.exports = __webpack_public_path__ + "static/media/lms-portal.bc8e9c1d.png";